import React, { useEffect, useState } from 'react';
import { addSpace } from '../../components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanDepPersoSurRecFct(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Part des dépenses de personnel sur les recettes " + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de gestion');
        
        var ComEpci = null;
        if (props.user.id_organisme_type === '1') {
            ComEpci = 'Com';
        }
        else if (props.user.id_organisme_type === '2') {
            ComEpci = 'Epci';
        }
        else if (props.user.id_organisme_type === '3') {
            ComEpci = 'Com';
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
              type: 'bar',
              height: 350,
              stackType: '100%'
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true) + "%";
                  }
                },
            },
            dataLabels: {
                formatter: (val) => {
                    return addSpace(val, true)+"%";
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4
                },
            },
            fill: {
              opacity: 1
            }
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'DepPersoSurRecReellesFct': true,
            'ComEpci': ComEpci,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
            'hypothese': 'R',
            'ba': props.user.budget_annexe,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {
            await setSeries([{
                name: filename,
                data: res.data[0],
                color: '#00b894',
                type: 'column',
            }])
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="bar"
            />:null}
		</div>
	)
}

export default BilanDepPersoSurRecFct;
